import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    class: _normalizeClass([
			'CampaignEditorInputField',
			{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing || _ctx.isFieldValidatedAndInvalid }
		]),
    type: "number",
    value: _ctx.storedCrmId,
    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setCrmIdBasedOnEvent && _ctx.setCrmIdBasedOnEvent(...args))),
    min: "0",
    max: "99999"
  }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
}